import { Stack, SxProps, Theme, Typography } from "@mui/material";
import { prefixClassName } from "@smartrr/shared/components/primitives";
import React, { ReactNode } from "react";
import styled from "styled-components";

interface Props {
  title?: string;
  subtitle?: string;
  children?: ReactNode;
  sx?: SxProps<Theme>;
}

const Wrapper = styled(Stack).attrs(props => ({
  ...props,
  className: prefixClassName("modal-center-text"),
}))`
  padding: 30px 0px;
  & [class*="subtitle"] {
    color: rgba(32, 34, 35, 0.7);
    max-width: 214px;
  }
  h3,
  p {
    margin: 0px;
  }
`;

export const CenterText = ({ title, children, subtitle, sx }: Props): JSX.Element => {
  return (
    <Wrapper
      direction="column"
      spacing="10px"
      justifyContent="center"
      textAlign="center"
      alignItems="center"
      sx={{ ...sx }}
    >
      {!!title && (
        <Typography variant="h3" component="div" className={prefixClassName("modal-center-text-title")}>
          {title}
        </Typography>
      )}
      {!!subtitle && (
        <Typography variant="body1" component="div" className={prefixClassName("modal-center-text-subtitle")}>
          {subtitle}
        </Typography>
      )}
      {!!children && (
        <Typography component="div" variant="body1">
          {children}
        </Typography>
      )}
    </Wrapper>
  );
};
